import {CheckboxControl, RadioControl, SelectControl} from '@wordpress/components';
import {__} from '@wordpress/i18n';
import axios from "axios";

function FireworkVideosSelect(props){
  return <SelectControl className={"wpfwv-rounded"} label={props.label} value={props.value} options={props.options} onChange={props.onChange} multiple={props.multiple} />
}

function FireworkLoading(props){
  if(props.loading){
    return <svg t="1617412984262" className="icon wpfwv-animate-spin wpfwv-pt-1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3842" width="24" height="24">
      <path d="M876.864 782.592c3.264 0 6.272-3.2 6.272-6.656 0-3.456-3.008-6.592-6.272-6.592-3.264 0-6.272 3.2-6.272 6.592 0 3.456 3.008 6.656 6.272 6.656z m-140.544 153.344c2.304 2.432 5.568 3.84 8.768 3.84a12.16 12.16 0 0 0 8.832-3.84 13.76 13.76 0 0 0 0-18.56 12.224 12.224 0 0 0-8.832-3.84 12.16 12.16 0 0 0-8.768 3.84 13.696 13.696 0 0 0 0 18.56zM552.32 1018.24c3.456 3.648 8.32 5.76 13.184 5.76a18.368 18.368 0 0 0 13.184-5.76 20.608 20.608 0 0 0 0-27.968 18.368 18.368 0 0 0-13.184-5.824 18.368 18.368 0 0 0-13.184 5.76 20.608 20.608 0 0 0 0 28.032z m-198.336-5.76c4.608 4.8 11.072 7.68 17.6 7.68a24.448 24.448 0 0 0 17.536-7.68 27.456 27.456 0 0 0 0-37.248 24.448 24.448 0 0 0-17.536-7.68 24.448 24.448 0 0 0-17.6 7.68 27.52 27.52 0 0 0 0 37.184z m-175.68-91.84c5.76 6.08 13.824 9.6 21.952 9.6a30.592 30.592 0 0 0 22.016-9.6 34.368 34.368 0 0 0 0-46.592 30.592 30.592 0 0 0-22.016-9.6 30.592 30.592 0 0 0-21.952 9.6 34.368 34.368 0 0 0 0 46.592z m-121.152-159.36c6.912 7.36 16.64 11.648 26.368 11.648a36.736 36.736 0 0 0 26.432-11.584 41.28 41.28 0 0 0 0-55.936 36.736 36.736 0 0 0-26.432-11.584 36.8 36.8 0 0 0-26.368 11.52 41.28 41.28 0 0 0 0 56zM12.736 564.672a42.88 42.88 0 0 0 30.784 13.44 42.88 42.88 0 0 0 30.784-13.44 48.128 48.128 0 0 0 0-65.216 42.88 42.88 0 0 0-30.72-13.44 42.88 42.88 0 0 0-30.848 13.44 48.128 48.128 0 0 0 0 65.216z m39.808-195.392a48.96 48.96 0 0 0 35.2 15.36 48.96 48.96 0 0 0 35.2-15.36 54.976 54.976 0 0 0 0-74.56 48.96 48.96 0 0 0-35.2-15.424 48.96 48.96 0 0 0-35.2 15.424 54.976 54.976 0 0 0 0 74.56zM168.32 212.48c10.368 11.008 24.96 17.408 39.68 17.408 14.592 0 29.184-6.4 39.552-17.408a61.888 61.888 0 0 0 0-83.84 55.104 55.104 0 0 0-39.616-17.408c-14.656 0-29.248 6.4-39.616 17.408a61.888 61.888 0 0 0 0 83.84zM337.344 124.8c11.52 12.16 27.712 19.264 43.968 19.264 16.256 0 32.448-7.04 43.968-19.264a68.672 68.672 0 0 0 0-93.184 61.248 61.248 0 0 0-43.968-19.264 61.248 61.248 0 0 0-43.968 19.264 68.736 68.736 0 0 0 0 93.184z m189.632-1.088c12.672 13.44 30.528 21.248 48.448 21.248s35.712-7.808 48.384-21.248a75.584 75.584 0 0 0 0-102.464A67.392 67.392 0 0 0 575.36 0c-17.92 0-35.776 7.808-48.448 21.248a75.584 75.584 0 0 0 0 102.464z m173.824 86.592c13.824 14.592 33.28 23.104 52.736 23.104 19.584 0 39.04-8.512 52.8-23.104a82.432 82.432 0 0 0 0-111.744 73.472 73.472 0 0 0-52.8-23.168c-19.52 0-38.912 8.512-52.736 23.168a82.432 82.432 0 0 0 0 111.744z m124.032 158.528c14.976 15.872 36.032 25.088 57.216 25.088 21.12 0 42.24-9.216 57.152-25.088a89.344 89.344 0 0 0 0-121.088 79.616 79.616 0 0 0-57.152-25.088c-21.184 0-42.24 9.216-57.216 25.088a89.344 89.344 0 0 0 0 121.088z m50.432 204.032c16.128 17.088 38.784 27.008 61.632 27.008 22.784 0 45.44-9.92 61.568-27.008a96.256 96.256 0 0 0 0-130.432 85.76 85.76 0 0 0-61.568-27.072c-22.848 0-45.44 9.984-61.632 27.072a96.192 96.192 0 0 0 0 130.432z" fill="#F40C70" p-id="3843"></path>
    </svg>
  }
  return <span className={"wpfwv-invisible"} />
}

function FireworkVideoPlayer(props){
  let spanZIndex = {zIndex: 999999999};
  return <div className={props.video ? "wpfwv-video-player" : "wpfwv-hidden"}>
    <div className={"wpfwv-absolute"}>
      <span role="img" aria-label="close-circle" tabIndex="-1" className={"wpfwv-absolute wpfwv-top-4 wpfwv-right-4 wpfwv-cursor-pointer"} style={spanZIndex} onClick={props.onClose}><svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1.5em" height="1.5em" fill="currentColor" aria-hidden="true" onClick={props.onClose}><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" /></svg></span>
      <video controls autoPlay disablePictureInPicture="" controlsList="nodownload" src={props.video} />
    </div>
  </div>
}

function FireworkVideoItem(props){
  let thumbnailStyle = {
    backgroundImage: `url(${props.thumbnail})`
  };
  let titleStyle = {
    marginTop: "-30px",
    marginLeft: "10px"
  };
  let checkboxStyle = {
    marginTop: "0.05rem",
    marginLeft: "0.25rem"
  };
  /*let radioClassName = "wpfwv-absolute wpfwv-invisible";
  if(props.videoId === props.value){
    radioClassName = "wpfwv-absolute wpfwv-visible"
  }else{
    if(props.hoverVideoId === props.value){
      radioClassName = "wpfwv-absolute wpfwv-visible"
    }
  }*/
  return <div className={"wpfwv-block wpfwv-cursor-pointer wpfwv-relative"} data-id={props.value} onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut}>
    <div className={'wpfwv-video-item wpfwv-m-1 wpfwv-block'} data-id={props.value}>
      {props.entity === "video" &&
      <div className={((props.videoId === props.value) || (props.hoverVideoId === props.value)) ? "wpfwv-absolute wpfwv-visible" : "wpfwv-absolute wpfwv-invisible"} style={checkboxStyle} data-id={props.value}>
        <input type="radio" data-id={props.value} name={"videoId"} value={props.value} defaultChecked={props.value === props.videoId} onClick={props.onVideoSelectClick} />
      </div>
      }
      <div className={'wpfwv-w-full wpfwv-h-full wpfwv-bg-cover wpfwv-bg-center wpfwv-block wpfwv-rounded'} style={thumbnailStyle} data-id={props.value} data-video={props.video} onClick={props.videoPlayerHandler} />
      <div className={"wpfwv-absolute wpfwv-m-1 wpfwv-text-white wpfwv-font-medium"} data-id={props.value} style={titleStyle}>{props.title}</div>
    </div>
  </div>
}

function FireworkVideosAdvancedOptions(props){
  return <div>
    <div className={"wpfwv-flex wpfwv-mb-2"}>
      <span className={"wpfwv-font-medium wpfwv-text-xs"}>{__("Advanced Options")}</span> {props.optionDisplayAdvanced === true &&
    <svg t="1617406172933" className={"icon wpfwv-cursor-pointer"} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3981" width="20" height="20" onClick={props.optionDisplayAdvancedHandleChange}>
      <path d="M960 704L512 256l-448 448z" fill="#262626" p-id="3982"></path>
    </svg>} {props.optionDisplayAdvanced === false &&
    <svg t="1617406105095" className={"icon wpfwv-cursor-pointer"} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3848" width="20" height="20" onClick={props.optionDisplayAdvancedHandleChange}>
      <path d="M64 320l448 448 448-448z" fill="#262626" p-id="3849"></path>
    </svg>}
    </div>
    <div className={props.optionDisplayAdvanced ? "wpfwv-block" : "wpfwv-hidden"}>
      <div className={"firework-videos-advanced-options-checkbox"}>
        <CheckboxControl className={"firework-videos-advanced-options-autoplay wpfwv-font-light"} label={__("Auto play")} onChange={props.autoplayOnChange} checked={props.autoplayValue} /> {props.layout === 'storyblock' &&
      <CheckboxControl className={"firework-videos-advanced-options-onlyshowsvideoselected wpfwv-font-light"} label={__("Only show selected video")} onChange={props.onlyShowVideosSelectedOnChange} checked={props.onlyShowVideosSelectedValue} />}
      </div>
      {props.layout === 'grid' &&
      <RadioControl className={"firework-videos-advanced-options-radio firework-videos-advanced-options-maxvideos"} label={__("Max videos")} selected={props.maxVideosValue} options={props.maxVideosOptions} onChange={props.maxVideosOnChange} />} {props.layout !== "storyblock" &&
    <RadioControl className={"firework-videos-advanced-options-radio firework-videos-advanced-options-openmethod"} label={__("Open Method")} selected={props.openMethodValue} options={props.openMethodOptions} onChange={props.openMethodOnChange} />}
    </div>
  </div>
}

export function FireworkVideosEmbedFeed(props){
  let playlistId;
  if(props.playlistId === "a_specific_video" || props.playlistId === "all_videos_in_channel"){
    playlistId = "";
  }else{
    playlistId = props.playlistId;
  }
  return <fw-embed-feed channel={props.channelUsername} mode={props.mode} open_in={props.openMethodValue} max_videos={props.maxVideosValue} autoplay={props.autoplay ? "true" : "false"} playlist={playlistId} />
}

export function FireworkVideosStoryblock(props){
  return <fw-storyblock channel={props.channelUsername} video={props.videoId} max_videos={props.onlyShowVideosSelected ? "1" : "0"} autoplay={props.autoplay ? "true" : "false"} />
}

export class FireworkVideosBlock extends React.Component{

  constructor(props){
    super(props);
    this.gutenberg = props.gutenberg;
    this.attributes = props.gutenberg.attributes;
    let channelValue = (typeof props.gutenberg.attributes.channelValue) === "undefined" ? true : props.gutenberg.attributes.channelValue;
    let channelUsername = (typeof props.gutenberg.attributes.channelUsername) === "undefined" ? true : props.gutenberg.attributes.channelUsername;
    let autoplay = (typeof props.gutenberg.attributes.autoplay) === "undefined" ? true : props.gutenberg.attributes.autoplay;
    let entity = (typeof props.gutenberg.attributes.entity) === "undefined" ? "" : props.gutenberg.attributes.entity;
    let layout = (typeof props.gutenberg.attributes.layout) === "undefined" ? "carousel" : props.gutenberg.attributes.layout;
    let onlyShowVideosSelected = (typeof props.gutenberg.attributes.onlyShowVideosSelected) === "undefined" ? false : props.gutenberg.attributes.onlyShowVideosSelected;

    let maxVideosValue = (typeof props.gutenberg.attributes.maxVideosValue) === "undefined" ? "0" : props.gutenberg.attributes.maxVideosValue;
    let openMethodValue = (typeof props.gutenberg.attributes.openMethodValue) === "undefined" ? "default" : props.gutenberg.attributes.openMethodValue;

    let businessId = (typeof props.gutenberg.attributes.businessId) === "undefined" ? "" : props.gutenberg.attributes.businessId;
    let channelId = (typeof props.gutenberg.attributes.channelId) === "undefined" ? "" : props.gutenberg.attributes.channelId;
    let playlistId = (typeof props.gutenberg.attributes.playlistId) === "undefined" ? "" : props.gutenberg.attributes.playlistId;
    let videos = (typeof props.gutenberg.attributes.videos) === "undefined" ? "" : props.gutenberg.attributes.videos;
    let videoId = (typeof props.gutenberg.attributes.videoId) === "undefined" ? "" : props.gutenberg.attributes.videoId;

    this.channelUsernameList = {};
    this.maxVideosOptions = [
      {
        label: __("Infinite"),
        value: "0"
      },
      {
        label: __("12"),
        value: "12"
      },
      {
        label: __("16"),
        value: "16"
      },
      {
        label: __("24"),
        value: "24"
      }
    ];
    this.openMethodOptions = [
      {
        label: __("Default"),
        value: "default"
      },
      {
        label: __("Modal"),
        value: "_modal"
      },
      {
        label: __("Self"),
        value: "_self"
      },
      {
        label: __("Blank"),
        value: "_blank"
      },
    ];
    this.state = {
      isLogin: false,
      authorizeUrl: "",
      videoUrl: "",
      playListLoading: false,
      channelListLoading: true,
      videoListLoading: false,
      optionDisplayAdvanced: false,
      expand: true,
      videoId: videoId,
      businessId: businessId,
      channelValue: channelValue,
      channelUsername: channelUsername,
      channelId: channelId,
      playlistId: playlistId,
      videos: videos,
      businessList: [],
      channelList: [],
      playList: [],
      videoList: [],
      entity: entity,
      layout: layout,
      autoplay: autoplay,
      maxVideosValue: maxVideosValue,
      onlyShowVideosSelected: onlyShowVideosSelected,
      openMethodValue: openMethodValue,
      hoverVideoId: ""
    };

    this.getBuildLoginUrl = this.getBuildLoginUrl.bind(this);
    this.videoPlayerHandler = this.videoPlayerHandler.bind(this);
    this.channelHandleChange = this.channelHandleChange.bind(this);
    this.playlistHandleChange = this.playlistHandleChange.bind(this);
    this.layoutHandleChange = this.layoutHandleChange.bind(this);
    this.entityHandleChange = this.entityHandleChange.bind(this);
    this.videoHandleChange = this.videoHandleChange.bind(this);
    this.optionAutoplayHandleChange = this.optionAutoplayHandleChange.bind(this);
    this.optionMaxvideosHandleChange = this.optionMaxvideosHandleChange.bind(this);
    this.optionOnlyShowVideosSelectedHandleChange = this.optionOnlyShowVideosSelectedHandleChange.bind(this);
    this.optionOpenMethodHandleChange = this.optionOpenMethodHandleChange.bind(this);
    this.expandHandler = this.expandHandler.bind(this);
    this.videoMouseOverHandle = this.videoMouseOverHandle.bind(this);
    this.videoMouseOutHandle = this.videoMouseOutHandle.bind(this);
    this.update = this.update.bind(this);
    this.getVideosByChannel = this.getVideosByChannel.bind(this);
    this.getVideos = this.getVideos.bind(this);
    this.getVideosByChannelPlayList = this.getVideosByChannelPlayList.bind(this);
    this.optionDisplayAdvancedHandleChange = this.optionDisplayAdvancedHandleChange.bind(this);
    this.getPlaylistByChannel = this.getPlaylistByChannel.bind(this);
    this.getChannelList = this.getChannelList.bind(this);
    this.checkLogin = this.checkLogin.bind(this);
  }

  videoPlayerHandler(e){
    this.setState({videoUrl: e.target.dataset.video});
  }

  optionDisplayAdvancedHandleChange(e){
    e.preventDefault();
    this.setState({optionDisplayAdvanced: !this.state.optionDisplayAdvanced});
  }

  videoMouseOverHandle(e){
    let hoverVideoId = e.target.dataset.id;
    this.setState({hoverVideoId: hoverVideoId});
  }

  videoMouseOutHandle(){
    this.setState({hoverVideoId: ""})
  }

  update(value){
    this.setState(value)
    this.gutenberg.setAttributes(value);
  }

  optionAutoplayHandleChange(autoplay){
    this.update({autoplay: autoplay});
  }

  optionMaxvideosHandleChange(maxVideosValue){
    this.update({maxVideosValue: maxVideosValue})
  }

  optionOnlyShowVideosSelectedHandleChange(onlyShowVideosSelected){
    this.update({onlyShowVideosSelected: onlyShowVideosSelected});
  }

  optionOpenMethodHandleChange(openMethodValue){
    this.update({openMethodValue: openMethodValue});
  }

  layoutHandleChange(e){
    let layout;
    if((typeof e) === "string"){
      layout = e;
    }else if((typeof e) === "object"){
      layout = e.target.dataset.layout;
    }else{
      layout = e;
    }

    this.update({layout: layout})
    if(layout === "carousel"){
      this.update({mode: "row"})
    }
    if(layout === "grid"){
      this.update({mode: "grid"})
    }
    if(layout === "carousel" || layout === "grid"){
      let playList = this.state.playList;
      playList.splice(1, 1);
      this.update({playList: playList});
    }else{
      let playList = this.state.playList;
      if(playList.length > 1){
        if(playList[1].value !== "a_specific_video"){
          playList.splice(1, 0, {
            label: __('A specific video'),
            value: 'a_specific_video'
          });
        }

      }else{
        playList.splice(1, 0, {
          label: __('A specific video'),
          value: 'a_specific_video'
        });
      }

      this.update({playList: playList});
    }
  }

  entityHandleChange(entity){
    this.update({entity: entity})
  }

  channelHandleChange(channelValue){
    let businessId, channelId, arr = channelValue.split('-');
    businessId = arr[0];
    channelId = arr[1];
    this.update({channelValue: channelValue});
    this.update({playList: []});
    this.update({playlistId: ""});
    this.update({videoList: []});
    this.update({videoId: ""});
    this.update({businessId: ""});
    this.update({channelId: ""});
    this.update({channelUsername: ""});
    this.update({entity: "all_videos_in_channel"});
    if(businessId === "" || channelId === ""){
      return false;
    }
    this.update({businessId: businessId});
    this.update({channelId: channelId});
    this.update({channelUsername: this.channelUsernameList[channelId]});
    this.getPlaylistByChannel(businessId, channelId);
    this.getVideosByChannel(businessId, channelId);
  }

  getPlaylistByChannel(businessId, channelId){
    this.setState({playListLoading: true});
    this.setState({
      playList: [
        {
          label: __('Play List Loading'),
          value: "0"
        }
      ]
    });
    axios.get(`/wp-admin/admin-ajax.php?action=firework_videos_block_get_playlists&business_id=${businessId}&channel_id=${channelId}`).then(res => {
      let data = res.data;
      this.setState({playListLoading: false})
      if(data.success === true){
        let list;
        list = data.data.map(playlist => {
          return {
            label: `playlist - ${playlist.name}`,
            value: playlist.id
          }
        });
        if(this.state.layout === 'storyblock'){
          list.unshift({
            label: __('A specific video'),
            value: 'a_specific_video'
          })
        }
        list.unshift({
          label: __('All videos in channel'),
          value: 'all_videos_in_channel'
        })
        this.setState({
          playList: list
        });
      }
    }).catch(function(){
      this.setState({playListLoading: false})
    })
  }

  expandHandler(e){
    e.preventDefault();
    this.update({expand: !this.state.expand});
  }

  playlistHandleChange(playlistId){
    this.update({videoList: []});
    this.update({videoId: ""});
    this.update({playlistId: playlistId})
    let entity;
    switch(playlistId){
      case 'all_videos_in_channel':{
        entity = "channel";
        this.getVideosByChannel(this.state.businessId, this.state.channelId);
        break;
      }
      case 'a_specific_video':{
        entity = "video";
        this.layoutHandleChange("storyblock");
        this.getVideosByChannel(this.state.businessId, this.state.channelId);
        break;
      }
      default:{
        entity = "playlist";
        this.getVideosByChannelPlayList(this.state.businessId, this.state.channelId, playlistId);
      }
    }

    this.entityHandleChange(entity);
  }

  getVideosByChannelPlayList(businessId, channelId, playlistId){
    this.setState({videoListLoading: true});
    axios.get(`/wp-admin/admin-ajax.php?action=firework_videos_block_get_videos_by_playlist&business_id=${businessId}&channel_id=${channelId}&playlist_id=${playlistId}`).then(res => {
      let data = res.data;
      this.setState({videoListLoading: false});
      if(data.success === true){
        let list = data.data.map(video => {
          return {
            title: video.caption,
            value: video.encoded_id,
            video_url: video.download_url,
            thumbnail_url: video.thumbnail_url
          };
        });
        this.setState({
          videoList: list
        });
      }
    }).catch(function(){
      this.setState({videoListLoading: false});
    })
  }

  getVideos(businessId, channelId, playlistId){
    if(businessId.length === 0 || channelId.length === 0){
      return false;
    }
    if(playlistId.length > 0 && (playlistId !== "a_specific_video" && playlistId !== "all_videos_in_channel")){
      this.getVideosByChannelPlayList(businessId, channelId, playlistId)
    }else{
      this.getVideosByChannel(businessId, channelId)
    }
  }

  getVideosByChannel(businessId, channelId){
    this.setState({videoListLoading: true});
    axios.get(`/wp-admin/admin-ajax.php?action=firework_videos_block_get_videos_by_channel&business_id=${businessId}&channel_id=${channelId}`).then(res => {
      let data = res.data;
      this.setState({videoListLoading: false});
      if(data.success === true){
        let list = data.data.map(video => {
          return {
            title: video.caption,
            value: video.encoded_id,
            video_url: video.download_url,
            thumbnail_url: video.thumbnail_url
          };
        });
        this.setState({
          videoList: list
        });
      }
    }).catch(function(){
      this.setState({videoListLoading: false});
    })
  }

  videoHandleChange(e){
    this.update({videoId: e.target.dataset.id});
  }

  componentDidMount(){
    this.setState({
      channelList: [
        {
          label: __("Channels loading..."),
          value: "",
        }
      ]
    });
    this.checkLogin();
    this.optionAutoplayHandleChange(this.state.autoplay);
    this.optionOpenMethodHandleChange(this.state.openMethodValue);
    this.layoutHandleChange(this.state.layout);
    this.getChannelList();
    this.getVideos(this.state.businessId, this.state.channelId, this.state.playlistId);
    if(this.state.businessId.length > 0 && this.state.channelId.length > 0){
      this.getPlaylistByChannel(this.state.businessId, this.state.channelId);
    }
    this.getBuildLoginUrl();
  }

  checkLogin(){
    axios.get('/wp-admin/admin-ajax.php?action=firework_videos_block_get_login_status').then(res => {
      let data = res.data;
      if(data.success === true){
        this.setState({
          isLogin: data.data.is_login
        });

      }
    })
  }

  getBuildLoginUrl(){

    axios.get('/wp-admin/admin-ajax.php?action=firework_videos_block_get_build_login_url').then(res => {
      let data = res.data;
      if(data.success === true){
        this.setState({
          authorizeUrl: data.data.url
        });

      }
    })
  }

  getChannelList(){
    axios.get('/wp-admin/admin-ajax.php?action=firework_videos_block_get_all_channels').then(res => {
      let list = [];
      let data = res.data;
      this.setState({channelListLoading: false});
      if(data.success === true){
        for(let bus of data.data){
          list.push({
            label: bus.name,
            value: bus.id,
            disabled: true
          })
          for(let channel of bus['channels']){
            this.channelUsernameList[channel.encoded_id] = channel.username;
            list.push({
              label: ` -- ${channel.name}`,
              value: `${channel.business_id}-${channel.encoded_id}`,
            })
          }
        }
        list.unshift({
          label: __("Please select a channel"),
          value: "0"
        })
        this.setState({
          channelList: list
        });

      }
    }).catch(function(){
      this.setState({channelListLoading: false});
    })
  }

  render(){
    let videos;
    if(this.state.videoList){
      videos = this.state.videoList.map(video =>
        <FireworkVideoItem entity={this.state.entity} videoId={this.state.videoId} title={video.title} value={video.value} thumbnail={video.thumbnail_url} video={video.video_url} hoverVideoId={this.state.hoverVideoId} onVideoSelectClick={this.videoHandleChange} onMouseOver={this.videoMouseOverHandle} onMouseOut={this.videoMouseOutHandle} videoPlayerHandler={this.videoPlayerHandler} />)
    }

    return <div {...this.props.editor}>
      {this.state.isLogin === false &&
      <div className="wpfwv-absolute wpfwv-top-0 wpfwv-left-0 wpfwv-flex wpfwv-justify-center wpfwv-items-center wpfwv-bg-gray-50 wpfwv-opacity-90 wpfwv-w-full wpfwv-h-full wpfwv-z-10">
        <div className="wpfwv-flex wpfwv-justify-center wpfwv-flex-col">
          <div className={"wpfwv-mb-1"}>You’re not signed in yet.</div>
          <a href={this.state.authorizeUrl} className={"wpfwv-link-text-color wp-firework-videos-bg-color wpfwv-py-2 wpfwv-px-4 wpfwv-text-white wpfwv-rounded"}>Connect to Firework</a>
        </div>
      </div>}
      <div className={"wpfwv-grid wpfwv-grid-cols-3"}>
        <div className={"wpfwv-flex wpfwv-flex-nowrap wpfwv-text-black wpfwv-font-semibold wpfwv-mb-1 wpfwv-leading-9"}>
          Embed Firework Videos
        </div>
        <div />
        <div className="wpfwv-text-right">
          <button type="button" className={"wpfwv-inline-flex wpfwv-cursor-pointer wpfwv-justify-center wpfwv-py-2 wpfwv-px-4 wpfwv-border wpfwv-border-transparent wpfwv-shadow-sm wpfwv-text-sm font-medium wpfwv-rounded-md wpfwv-text-white wpfwv-bg-indigo-600 hover:wpfwv-bg-indigo-700 focus:wpfwv-outline-none focus:wpfwv-ring-2 focus:wpfwv-ring-offset-2 focus:wpfwv-ring-indigo-500 wp-firework-videos-bg-color"} onClick={this.expandHandler}>
            {this.state.expand ? __("Done") : __('Edit')}
          </button>
        </div>
      </div>
      <div className={this.state.expand ? '' : 'wpfwv-hidden'}>
        <div className={"wpfwv-flex wpfwv-flex-nowrap wpfwv-text-black wpfwv-font-light wpfwv-text-sm"}>
          I want my videos to appear in a
        </div>
        <div className={"wpfwv-grid wpfwv-grid-cols-5"}>
          <div className={this.state.layout === "carousel" ? "wpfwv-cursor-pointer wpfwv-rounded wpfwv-layout-carousel wpfwv-item-selected" : "wpfwv-cursor-pointer wpfwv-rounded wpfwv-layout-carousel"} data-layout={"carousel"} onClick={this.layoutHandleChange} />
          <div className={this.state.layout === "grid" ? "wpfwv-cursor-pointer wpfwv-rounded wpfwv-layout-grid wpfwv-item-selected" : "wpfwv-cursor-pointer wpfwv-rounded wpfwv-layout-grid"} data-layout={"grid"} onClick={this.layoutHandleChange} />
          <div className={this.state.layout === "storyblock" ? "wpfwv-cursor-pointer wpfwv-rounded wpfwv-layout-storyblock wpfwv-item-selected" : "wpfwv-cursor-pointer wpfwv-rounded wpfwv-layout-storyblock"} data-layout={"storyblock"} onClick={this.layoutHandleChange} />
          <div className={"wpfwv-col-span-2 wpfwv-relative"}>
            <div className={"wpfwv-absolute wpfwv-bottom-0 wpfwv-right-0 wpfwv-flex wpfwv-justify-center"}>
              <div>
                <a href={"https://business.fireworktv.com"} className={"wpfwv-text-gray-500"} target="_blank">
                  <span className={"wpfwv-font-light wpfwv-text-base"}>Manage content on </span> </a>
              </div>
              <div className="wpfwv-border-none wpfwv-w-20 wpfwv-manage-logo">
                <img src={"data:image/png;base64,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"} />
              </div>
            </div>
          </div>
        </div>
        <div className={"wpfwv-border wpfwv-border-solid wpfwv-border-gray-200 wpfwv-rounded wpfwv-my-4 wpfwv-p-2"}>
          <div className={"wpfwv-grid wpfwv-grid-cols-2 wpfwv-my-2"}>
            <div className={"wpfwv-grid wpfwv-mr-2"}>
              <div className={"wpfwv-flex wpfwv-justify-start"}>
                <div className={"wpfwv-mr-2 wpfwv-text-black wpfwv-font-semibold wpfwv-leading-8"}>{__("Channel")}</div>
                <FireworkVideosSelect options={this.state.channelList} value={this.state.channelValue} onChange={this.channelHandleChange} />
                <div className={"wpfwv-ml-2"}>
                  <FireworkLoading loading={this.state.channelListLoading} />
                </div>
              </div>
            </div>
            <div className={"wpfwv-flex wpfwv-justify-start"}>
              <FireworkVideosSelect options={this.state.playList} value={this.state.playlistId} onChange={this.playlistHandleChange} />
              <div className={"wpfwv-ml-2"}>
                <FireworkLoading loading={this.state.playListLoading} />
              </div>
            </div>
          </div>
          <div className={"wpfwv-ml-2"}>
            <FireworkLoading loading={this.state.videoListLoading} />
          </div>
          {this.state.videoList.length > 0 &&
          <div className={"wpfwv-grid wpfwv-grid-cols-4 wpfwv-overflow-auto wpfwv-h-72"}>{videos}</div>} {(this.state.videoList.length === 0 && this.state.channelId.length > 0 && this.state.videoListLoading === false) &&
        <div className={"wpfwv-flex wpfwv-h-8"}>{__("No video found")}</div>}
        </div>
        <FireworkVideosAdvancedOptions optionDisplayAdvanced={this.state.optionDisplayAdvanced} optionDisplayAdvancedHandleChange={this.optionDisplayAdvancedHandleChange} autoplayClassName={"firework-video-block-advanced-options"} autoplayOnChange={this.optionAutoplayHandleChange} layout={this.state.layout} autoplayValue={this.state.autoplay} maxVideosValue={this.state.maxVideosValue} maxVideosOptions={this.maxVideosOptions} maxVideosOnChange={this.optionMaxvideosHandleChange} entity={this.state.entity} onlyShowVideosSelectedOnChange={this.optionOnlyShowVideosSelectedHandleChange} onlyShowVideosSelectedValue={this.state.onlyShowVideosSelected} openMethodOptions={this.openMethodOptions} openMethodValue={this.state.openMethodValue} openMethodOnChange={this.optionOpenMethodHandleChange} />
      </div>
      <FireworkVideoPlayer video={this.state.videoUrl} onClose={() => this.setState({videoUrl: ""})} />
    </div>
      ;
  }
}
